import React from 'react';

import { useGroupBy } from '@neptune/shared/leaderboard-business-logic';
import {
  GroupByModelConverter,
  LeaderboardQueryNameAliases,
} from '@neptune/shared/leaderboard-domain';

import { useEntityLeaderboardPolling } from './use-entity-leaderboard-polling';

type UseEntityLeaderboardPollingWithGroupingParams = {
  queryNameAliases?: LeaderboardQueryNameAliases;
  /**
   * This contains a list of sys/id no matter if it's a run or experiment
   */
  compareIds?: string[];
  /**
   * Contains experiments sys/name used to filter out table to specific experiments
   */
  selectedExperimentNames?: string[];
  /**
   * Contains runs sys/id used to filter out table to specific runs
   */
  selectedRunIds?: string[];
  enabled?: boolean;
  projectIdentifier: string;
};

export function useEntityLeaderboardPollingWithGrouping({
  queryNameAliases,
  compareIds,
  selectedRunIds,
  selectedExperimentNames,
  enabled,
  projectIdentifier,
}: UseEntityLeaderboardPollingWithGroupingParams) {
  const { isEnabled: groupByMode, options: groupByOptions, openedGroups } = useGroupBy();

  const grouping = React.useMemo(() => {
    if (!groupByMode || !groupByOptions) {
      return undefined;
    }

    return {
      groupBy: GroupByModelConverter.fromGroupOptionsToDomain(groupByOptions),
      openedGroups,
      compareIds,
    };
  }, [groupByMode, groupByOptions, openedGroups, compareIds]);

  return useEntityLeaderboardPolling({
    queryNameAliases,
    grouping,
    selectedRunIds,
    selectedExperimentNames,
    enabled,
    projectIdentifier,
  });
}
